import React from 'react'
import ProjectTemplate from '../../Projects/ProjectTemplate/ProjectTemplate'
import CheetSheetTemplate from '../CheetSheet/CheetSheetTemplate'
import { uiux } from '../../../utils/constants';
export default function UiUx(props) {
    return (
        <>
            <ProjectTemplate name='UI UX Design' mode={props.mode} isValue={props.isValue} >
                <div className="aboutMe blogDiv">
                    {
                        uiux.map((category,index)=>(
                            <CheetSheetTemplate
                                key={index}
                                imgClass={category.imgClass}
                                heading={category.heading}
                                headStyle={category.headStyle}
                                des={category.des}
                                url={category.url}
                                divStyle={category.divStyle}
                                img={category.img}
                                headerStyle={category.headerStyle}
                                class={category.class}
                            />
                        ))
                    }
                </div>

            </ProjectTemplate>
        </>
    )
}
